<template>
  <el-dialog
      :visible="true"
      :close-on-click-modal="false"
      width="650px"
      :before-close="handleClose"
  >
    <div slot="title">
      Készlet transzformáció létrehozása
    </div>

    <div v-loading="loading">
      <el-form
          ref="stockTransformationForm"
          label-position="top"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
                prop="source_storage"
                label="Raktár"
            >
              <el-select
                  v-model="storage"
                  style="width: 100%;"
                  value-key="id"
                  filterable
              >
                <el-option
                    v-for="storage in storages"
                    v-show="storage.type === 'own'"
                    :key="storage.id"
                    :value="storage"
                    :label="storage.name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
                label="Termék"
            >
              <el-select
                  v-model="product"
                  filterable
                  remote
                  clearable
                  :remote-method="searchProducts"
                  placeholder="Gépelj a kereséshez..."
                  style="width: 100%;"
                  value-key="id"
                  @change="handleProductChange"
                  :disabled="productDisabled"
              >
                <el-option
                    v-for="p in products"
                    :key="p.id"
                    :value="p"
                    :label="p.name"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item
                label="Induló kiszerelés"
            >
              <el-select
                  v-model="product_pack_type"
                  filterable
                  placeholder="Gépelj a kereséshez..."
                  style="width: 100%;"
                  value-key="id"
                  @change="handleProductPackTypeChange"
                  :disabled="productPackTypeDisabled"
              >
                <el-option
                    v-for="pack in productPackTypes"
                    :key="pack.id"
                    :value="pack"
                    :label="pack.name"
                >
                  {{ pack.name }} ({{ pack.count_per_pack }} db / kiszerelés)
                  <span
                      style="float: right; color: #8492a6; font-size: 13px; margin-left: 20px;"
                  >
                        <el-tag
                            size="mini"
                            type="info"
                        >
                            {{ pack.count || 0 }} <span v-if="pack.count_per_pack === 1">db</span><span v-else>{{ pack.name }}</span> készleten
                         </el-tag>
                    </span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
                prop="supplier"
                label="Beszállító"
            >
              <el-select
                  v-model="supplier"
                  style="width: 100%;"
                  value-key="id"
                  filterable
                  @change="handleSupplierChange"
                  :disabled="supplierDisabled"
              >
                <el-option
                    v-for="supp in suppliers"
                    :key="supp.id"
                    :value="supp"
                    :label="`#${supp.id} ${supp.name}`"
                >
                  #{{ supp.id }} {{ supp.name }}
                  <span
                      style="float: right; color: #8492a6; font-size: 13px; margin-left: 20px;"
                  >
          <el-tag
              size="mini"
              type="info"
          >
            {{ supp.count || 0 }} {{ product_pack_type.name }} készleten
          </el-tag>
        </span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
                prop="expiration_date"
                label="Szav. idő"
            >
              <el-select
                  v-model="expiration"
                  @change="handleExpirationDateChange"
                  :disabled="expirationDateDisabled"
              >
                <el-option
                    v-for="exp in expirationDates"
                    :key="exp.id"
                    :value="exp"
                    :label="$options.filters.date(expiration.expiration_date)"
                >
                  {{ exp.expiration_date | date }}
                  <span
                      v-if="exp.count"
                      style="float: right; color: #8492a6; font-size: 13px; margin-left: 20px;"
                  >
        <el-tag
            size="mini"
            type="info"
        >
          {{ expiration.count }} {{ product_pack_type.name }} készleten
        </el-tag>
      </span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
                label="Végső kiszerelés"
            >
              <el-select
                  v-model="to_product_pack_type"
                  filterable
                  clearable
                  placeholder="Gépelj a kereséshez..."
                  style="width: 100%;"
                  value-key="id"
                  :disabled="toProductPackTypeDisabled"
              >
                <el-option
                    v-for="pack in toProductPackTypesFiltered"
                    :key="pack.id"
                    :value="pack"
                    :label="pack.name"
                >
                  {{ pack.name }} ({{ pack.count_per_pack }} db / kiszerelés)
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" v-if="!calculatorDisabled">
          <el-col :span="11">
            <el-card style="height: 100%;
    display: flex;
    align-items: center;">
              <el-input v-model.number="count" v-if="product_pack_type" @change="handleCountChange">
                <template slot="append"><span v-if="product_pack_type.count_per_pack === 1">db</span><span v-else>{{ product_pack_type.name }}</span>
                </template>
              </el-input>
              <el-alert
                  style="margin-top: 10px;"
                  v-show="showStockWarning"
                  show-icon
                  title="Nincs ennyi termék készleten!"
                  type="error"
                  :closable="false">
              </el-alert>
            </el-card>
          </el-col>
          <el-col :span="2" style="display: flex; align-items: center; justify-content: center;">
            <i class="el-icon-right" style="font-size: 2rem"></i>
          </el-col>
          <el-col :span="11">
            <el-card>
              <el-input v-model.number="to_count" v-if="to_product_pack_type" @change="handleToCountChange">
                <template slot="append"><span v-if="to_product_pack_type.count_per_pack === 1">db</span><span v-else>{{ to_product_pack_type.name }}</span>
                </template>
              </el-input>
               <el-form-item
                 style="margin-top: 15px"
                  prop="supplier"
                  label="Beszállító"
                >
                 <el-select
                   v-model="to_supplier"
                   filterable
                   remote
                   :remote-method="searchSuppliersByQuery"
                   :loading="toSupplierLoading"
                   placeholder="Gépelj a kereséshez..."
                   style="width: 100%;"
                   value-key="id"
                   clearable
                 >
                    <el-option
                      v-for="supp in to_suppliers"
                      :key="supp.id"
                      :value="supp"
                      :label="`#${supp.id} ${supp.company.name}`"
                    >
                      #{{ supp.id }} {{ supp.company.name }}
                    </el-option>
                  </el-select>
                </el-form-item>
              <el-form-item
                label="Szav. idő"
              >
                <el-date-picker
                  v-model="to_expiration"
                  style="width: 100%;"
                  :clearable="false"
                  format="yyyy. MM. dd."
                  value-format="yyyy-MM-dd"
                  :picker-options="dateRangeOptions"
                />
              </el-form-item>
            </el-card>
          </el-col>
        </el-row>
        <el-tag
            style="margin-top: 10px"
            size="mini"
            type="success"
            v-if="!calculatorDisabled"
        >
          {{ expiration.count || 0 }} <span v-if="product_pack_type.count_per_pack === 1">db</span><span v-else>{{ product_pack_type.name }}</span>
          készleten
        </el-tag>
      </el-form>
    </div>
    <div
        slot="footer"
        class="dialog-footer"
    >
      <el-button
          type="primary"
          @click="store"
          :disabled="buttonDisabled"
      >
        Hozzáadás
      </el-button>
    </div>
  </el-dialog>
</template>

<script>

  export default {
    components: {},
    data() {
      return {
        product: null,
        storage: null,
        supplier: null,
        product_pack_type: null,
        to_product_pack_type: null,
        to_supplier: null,
        to_expiration: null,
        expiration: null,
        count: 0,
        to_count: 0,
        products: [],
        suppliers: [],
        to_suppliers: [],
        productPackTypes: [],
        toProductPackTypes: [],
        expirationDates: [],
        loading: false,
        toSupplierLoading: false,
        dateRangeOptions: {
          firstDayOfWeek: 1,
        },
      };
    },

    computed: {
      storages() {
        return this.$store.getters['storage/storages'];
      },

      productDisabled() {
        return !this.storage;
      },

      productPackTypeDisabled() {
        return this.productDisabled || !this.product;
      },

      supplierDisabled() {
        return this.productPackTypeDisabled || !this.product_pack_type
      },

      expirationDateDisabled() {
        return this.supplierDisabled || !this.supplier;
      },

      toProductPackTypeDisabled() {
        return this.expirationDateDisabled || !this.expiration
      },

      calculatorDisabled() {
        return this.toProductPackTypeDisabled || !this.to_product_pack_type;
      },

      showStockWarning() {
        if (this.calculatorDisabled) {
          return false;
        }

        return this.count > this.expiration.count;
      },

      buttonDisabled() {
        return this.calculatorDisabled || this.count === 0 || this.count_to === 0 || this.showStockWarning;
      },

      toProductPackTypesFiltered() {
        return this.toProductPackTypes //.filter(p => p.id !== this.product_pack_type.id)
      }
    },

    async mounted() {
      if (!this.storages.length) {
        await this.$store.dispatch('storage/fetchAll');
      }

      const ownStorage = this.storages.find(s => s.type === 'own');
      this.storage = ownStorage;
    },

    methods: {
      async searchProducts(val) {
        this.products = await axios.get('api/stock-transformations/products?storage_id=' + this.storage.id + '&name=' + val)
      },

      async searchProductPackTypes() {
        this.productPackTypes = await axios.get('api/stock-transformations/product-pack-types?storage_id=' + this.storage.id + '&product_id=' + this.product.id)

        if (this.productPackTypes.length === 1) {
          this.product_pack_type = this.productPackTypes[0];
          this.handleProductPackTypeChange();
        }
      },

      async searchToProductPackTypes() {
        this.toProductPackTypes = await axios.get('api/stock-transformations/to-product-pack-types?&product_id=' + this.product.id)

        if (this.toProductPackTypesFiltered.length === 1) {
          this.to_product_pack_type = this.toProductPackTypesFiltered[0];
        }
      },

      async searchSuppliers() {
        this.suppliers = await axios.get('/api/stock-transformations/suppliers?storage_id=' + this.storage.id + '&product_id=' + this.product.id + '&product_pack_type_id=' + this.product_pack_type.id)

        if (this.suppliers.length === 1) {
          this.supplier = this.suppliers[0];
          this.handleSupplierChange();
        }
      },

      async searchSuppliersByQuery(query) {
        if (query !== '') {
          this.toSupplierLoading = true;
          this.to_suppliers = await this.$store.dispatch('partner/search', '?name=' + query + '&is_supplier=true');
          this.toSupplierLoading = false;
        }
      },

      async searchExpirationDates() {
        this.expirationDates = await axios.get(
          '/api/stock-transformations/expiration-dates?storage_id=' +
          this.storage.id +
          '&product_id=' + this.product.id +
          '&product_pack_type_id=' + this.product_pack_type.id +
          '&supplier_id=' + this.supplier.id
        )

        if (this.expirationDates.length === 1) {
          this.expiration = this.expirationDates[0];
          this.handleExpirationDateChange();
        }
      },

      handleProductChange() {
        this.searchProductPackTypes();
        this.searchToProductPackTypes();
        this.product_pack_type = "";
        this.supplier = "";
        this.expiration = "";
        this.count = 0;
        this.to_count = 0;
      },

      handleProductPackTypeChange() {
        this.searchSuppliers();
        this.supplier = "";
        this.expiration = "";
        this.to_product_pack_type = "";
        this.count = 0;
        this.to_count = 0;
      },

      handleSupplierChange() {
        this.searchExpirationDates();
        this.expiration = "";
        this.count = 0;
        this.to_count = 0;
        this.to_supplier = this.supplier;
        this.to_suppliers.push({
          id: this.supplier.id,
          company: {
            name: this.supplier.name,
          }
        });
      },

      handleExpirationDateChange() {
        this.count = 0;
        this.to_count = 0;
        this.to_expiration = this.expiration.expiration_date;
      },

      handleCountChange() {
        let calculated = (this.count * this.product_pack_type.count_per_pack) / this.to_product_pack_type.count_per_pack

        if (Number.isInteger(calculated)) {
          this.to_count = calculated;
        } else {
          this.to_count = Math.round(calculated);
          this.count = (this.to_count * this.to_product_pack_type.count_per_pack) / this.product_pack_type.count_per_pack
        }
      },

      handleToCountChange() {
        let calculated = (this.to_count * this.to_product_pack_type.count_per_pack) / this.product_pack_type.count_per_pack

        if (Number.isInteger(calculated)) {
          this.count = calculated;
        } else {
          this.count = Math.round(calculated);
          this.to_count = (this.count * this.product_pack_type.count_per_pack) / this.to_product_pack_type.count_per_pack
        }
      },

      handleClose() {
        return this.$router.replace('/processes/stock-transformations');
      },

      store() {
        axios.post('/api/stock-transformations', {
          product_id: this.product.id,
          storage_id: this.storage.id,
          supplier_id: this.supplier.id,
          product_pack_type_id: this.product_pack_type.id,
          to_product_pack_type_id: this.to_product_pack_type.id,
          to_supplier_id: this.to_supplier.id,
          to_expiration: this.to_expiration,
          expiration_date: this.expiration.expiration_date,
          count: this.count,
        }).then(() => {
          this.$store.dispatch('stockTransformation/fetchAll');
          return this.$router.replace('/processes/stock-transformations');
        })
      }
    }
  };
</script>

<style lang="scss">
  .price-sum {
    margin-top: 20px;
    text-align: right;
    font-size: 18px;

    > div {
      display: inline-block;
    }
  }
</style>
